module.exports = __webpack_public_path__ + "a6d4c1d7ddda28cbe47e2b6dc5141096.pdf";